import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

import LandingPage from "../pages/LandingPage";
import Login from "../components/Login";
import RegisterPage from "../pages/RegisterPage";
import SoftwarePage from "../components/SoftwarePage";
import ContactosPage from "../components/ContactosPage";

import Dashboard from "../pages/Dashboard";
import EstatisticasAlunos from "../pages/EstatisticasAlunos";
import PreRegistoAluno from "../components/PreRegistoAluno";
import ListaAlunos from "../components/ListaAlunos/ListaAlunos";
import Matriculas from "../pages/Matriculas";
import ListaDesativados from "../components/ListaDesativados/ListaDesativados";
import RelatoriosPagamentos from "../components/Pagamentos/RelatoriosPagamentos";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import UsuarioForm from "../components/UsuarioForm";
import PrivateLayout from "../layouts/PrivateLayout";
import PortalDebito from "../components/Portal/PortalDebito";

// ✅ Componente de rota protegida
const ProtectedRoute = ({ element, redirectTo }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? element : <Navigate to={redirectTo} />;
};

const AppRoutes = ({ currentUser }) => {
  return (
    <Routes>
      {/* Rotas públicas */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/software" element={<SoftwarePage />} />
      <Route path="/contactos" element={<ContactosPage />} />
      <Route path="/alunos-desativados" element={<ListaDesativados />} />
      <Route path="/pagamentos/relatorios" element={<RelatoriosPagamentos />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />
      <Route path="/usuarios" element={<UsuarioForm currentUser={currentUser} />} />
      <Route path="/portal-pagamento" element={<PortalDebito />} />

      {/* Rotas protegidas */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute
            element={
              <PrivateLayout>
                <Dashboard />
              </PrivateLayout>
            }
            redirectTo="/login"
          />
        }
      />
      <Route
        path="/alunos"
        element={
          <ProtectedRoute
            element={
              <PrivateLayout>
                <PreRegistoAluno />
                <ListaAlunos />
              </PrivateLayout>
            }
            redirectTo="/login"
          />
        }
      />
      <Route
        path="/estatisticas"
        element={
          <ProtectedRoute
            element={
              <PrivateLayout>
                <EstatisticasAlunos />
              </PrivateLayout>
            }
            redirectTo="/login"
          />
        }
      />
      <Route
        path="/matriculas"
        element={
          <ProtectedRoute
            element={
              <PrivateLayout>
                <Matriculas />
              </PrivateLayout>
            }
            redirectTo="/login"
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
